import config, { apis } from '@app/config'

import { createInstance } from './createInstance'

export const backendApi = createInstance({
  baseURL: config.apis.backend,
})

export const contentsApi = createInstance({
  baseURL: config.apis.contentsApi,
})

export const communicationsApi = createInstance({
  baseURL: config.apis.communicationsApi,
})

export const spamDetectionApi = createInstance({
  baseURL: config.apis.spamDetectionApi,
})

export const listingsApiV1 = createInstance({
  baseURL: `${config.apis.listingsApi}v1`,
})

export const listingsApiV2 = createInstance({
  baseURL: `${config.apis.listingsApi}v2`,
})

export const unauthorizedBackendApi = createInstance({
  requireAuth: false,
  baseURL: config.apis.backend,
})

export const usersApi = createInstance({
  baseURL: apis.usersApi,
})

export const accountsApi = createInstance({
  baseURL: apis.accountsApi,
})
